var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tabs-bar-item tw-cursor-pointer tw-appearance-none tw-border-none tw-text-center tw-items-center tw-flex tw-h-full tw-max-h-full tw-px-3",class:{
    active: _vm.$attrs.active
  },attrs:{"title":_vm.title,"disabled":_vm.$attrs.disabled,"type":"button"}},[_c('span',{staticClass:"tw-mx-auto tw-truncate",domProps:{"textContent":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }